import PropTypes from "prop-types";

import {
  INTERVENTION_INCLUDES,
  useGetIntervention,
} from "@/entities/intervention";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import InterventionEdit from "./InterventionEdit.component";

const InterventionEditWrapper = ({ interventionId }) => {
  const { intervention, isLoading } = useGetIntervention(interventionId, {
    params: { include: INTERVENTION_INCLUDES.USERS },
  });

  return (
    <FetchItemWrapper
      item={intervention}
      loading={isLoading}
      renderContent={(intervention) => (
        <InterventionEdit model={intervention} />
      )}
    />
  );
};

InterventionEditWrapper.propTypes = {
  interventionId: PropTypes.number.isRequired,
};

export default InterventionEditWrapper;
